<template>
  <div>
    <div class="p-20 justify-content-center d-flex">
      <div class="content-container-mobile">
        <div class="style-group">
          <style-description></style-description>
          <style-selector></style-selector>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import StyleDescription from "../Settings/StyleDescription.vue";
import StyleSelector from "../Settings/StyleSelector.vue";

export default {
  name: "MobileStyles",
  props: {},
  components: {
    StyleSelector,
    StyleDescription,
  },
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss">
.content-container-mobile {
  width: 100%;
}

.style-group {
  gap: 30px;
  display: flex;
  flex-direction: column;
}
</style>
